import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Card from 'antd/lib/card';
import Statistic from 'antd/lib/statistic';

import styles from './stats-container.module.css';

export default function StatsContainer({ averages }) {
    return (
        <Row gutter={16} className={styles.statsContainer}>
                <Col span={4}>
                    <Card>
                        <Statistic title="Overall Timeliness" value={averages.timeliness} suffix="/5" />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card>
                        <Statistic title="Overall Performance" value={averages.performance} suffix="/5" />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card>
                        <Statistic title="Overall Communication" value={averages.communication} suffix="/5" />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card>
                        <Statistic title="Overall Professionalism" value={averages.professionalism} suffix="/5" />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card>
                        <Statistic title="Overall Rating" value={averages.overall} suffix="/5" />
                    </Card>
                </Col>
            </Row>
    )
}